import { useEffect } from 'react';
export const useListenFor = (messageName, handler) => {
    useEffect(() => {
        nodecg.listenFor(messageName, handler);
        return () => {
            nodecg.unlisten(messageName, handler);
        };
    }, []);
};
//# sourceMappingURL=index.js.map